export const getAge = (dateString) => {
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export const getDay = (dateString) => {
    let birthDate = new Date(dateString);
    let day = birthDate.getDay();
    let res;

    switch (day) {
        case 1:
            res = "monday";
            break;
        case 2:
            res = "tuesday";
            break;
        case 3:
            res = "wendesday";
            break;
        case 4:
            res = "thursday";
            break;
        case 5:
            res = "friday";
            break;
        case 6:
            res = "saturday";
            break;
        case 7:
            res = "sunday";
            break;
        default:
            res = "day";
    }

    return res;
}
